module.exports = __webpack_public_path__ + "img/3.961f4a00.png";